<template>
    <v-container class="pb-0">
        <v-data-table
            :items="markSheetRecordsFilter"
            :loading="loading"
            :headers="headers"
            :height="height"            
            fixed-header           
            class="enter-marks-table"
            disable-pagination
            hide-default-footer                                       
        >
            <template v-slot:item="props">
                <Record
                    v-bind:studentRecord="props.item"
                    v-bind:index="props.index"
                />
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import Record from './EnterMarksSheetRecord';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    components: {
        Record,
    },
    created () {
        //this.initialize();
    },

    watch: {
        lessonSelected: function (val) {
            if(val) this.initialize();
        },

        markSheetClassesFilter: function () {
            this.filter = true;
            this.getFilterTable2Records();
        },

        table2Records: function (val) {
            if(this.filter) return;
            this.setMarkSheetRecordsFilter([]);
            this.$nextTick(() => this.setMarkSheetRecordsFilter(JSON.parse(JSON.stringify(val))));
        }
        
    },

    data: () =>({
        loading: false,
        height: "45vh",
        pagination: false,
        footer: false,                
        headers: [],       
        filter: false,
    }),

    computed:{
        ...mapGetters({            
            table2Records: 'termReports/getTable2Records',
            currentTerm: 'termReports/getCurrentTerm',
            lessonSelected: 'termReports/getLessonSelected',
            markSheetClassesFilter: 'termReports/getMarkSheetClassesFilter',
            markSheetRecordsFilter: 'termReports/getMarkSheetRecordsFilter',
            employeeId: 'auth/getEmployeeId',
        }),
    },
    methods: { 

        ...mapMutations({
            setMarkSheetRecordsFilter: 'termReports/setMarkSheetRecordsFilter',
        }),

        ...mapActions({
            getStudents: 'termReports/getStudents',
        }),

        initialize(){
            if(this.lessonSelected.formLevel < 4){
                this.headers = [
                    {text: '#', value: 'count', width: '45', sortable: false},
                    {text: 'Name', value: 'name', width: '110', sortable: false,},
                    {text: 'Term', value: 'courseMark', align: 'center', width: '80', sortable: false,},            
                    {text: 'Exam', value: 'examMark', align: 'center', width: '80', sortable: false,},            
                    {text: 'Total', value: 'conduct', align: 'center', width: '90', sortable: false,},
                    {text: 'Coded Comment', value: 'codedComment1', align: 'center', width: '100', sortable: false,},            
                    {text: 'Coded Comment 1',  value: 'codedComment2', align: 'center', width: '100', sortable: false,},
                    {text: ' ', value: 'actions', align: 'center', sortable: false, width: '40'},                        
                ] 
                return;
            }

            this.headers = [
                {text: '#', value: 'count', width: '45', sortable: false},
                {text: 'Class', value: 'class_id', width: '45', sortable: false},
                {text: 'Name', value: 'name', width: '110', sortable: false,},
                {text: 'Term', value: 'courseMark', align: 'center', width: '80', sortable: false,},            
                {text: 'Exam', value: 'examMark', align: 'center', width: '80', sortable: false,},            
                {text: 'Total', value: 'conduct', align: 'center', width: '90', sortable: false,},
                {text: 'Coded Comment', value: 'codedComment1', align: 'center', width: '100', sortable: false,},            
                {text: 'Coded Comment 1',  value: 'codedComment2', align: 'center', width: '100', sortable: false,},
                {text: ' ', value: 'actions', align: 'center', sortable: false, width: '40'},                        
            ] 

       },

       async getFilterTable2Records () {
           this.loading = true;
            try {
                await this.getStudents(this.employeeId);
                const table2RecordsFilter = this.table2Records.filter( record =>  this.markSheetClassesFilter.includes(record.class_id) );
                this.setMarkSheetRecordsFilter([]);
                this.$nextTick(() => {
                    this.setMarkSheetRecordsFilter(JSON.parse(JSON.stringify(table2RecordsFilter)));
                })
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            } finally {
                this.loading = false;
            }
            this.filter = false;
        },
    }
}
</script>

<style>
    .v-text-field__slot textarea{
        font-size: 13px;
    }
    .v-data-table > .v-data-table__wrapper > table{
        table-layout: fixed;
    }
    th span{
        display: flex;
    }
</style>